import { HTMLAttributes } from "react";

export default function TailwindCSS(props: HTMLAttributes<SVGElement>) {
  return (
    <svg
    {...props}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24.0015 9.60075C17.6013 9.60075 13.6027 12.7995 12.0015 19.1996C14.4007 16.0005 17.2016 14.8009 20.4007 15.6008C22.2273 16.056 23.5327 17.3805 24.9783 18.8483C27.3311 21.2359 30.0543 24 36.0015 24C42.4012 24 46.4002 20.8009 48.0015 14.3993C45.6018 17.6002 42.8013 18.7999 39.6018 18C37.7756 17.5444 36.4717 16.2203 35.0242 14.7525C32.673 12.3649 29.9505 9.60075 24.0015 9.60075ZM12.0015 24C5.60172 24 1.60271 27.1991 0.00146484 33.6007C2.40071 30.3997 5.20122 29.2001 8.40071 30C10.2273 30.4556 11.5327 31.7798 12.9783 33.2475C15.3311 35.6351 18.0543 38.3993 24.0015 38.3993C30.4012 38.3993 34.4002 35.2005 36.0015 28.8004C33.6018 31.9995 30.8013 33.1991 27.6018 32.3993C25.7756 31.944 24.4717 30.6195 23.0242 29.1518C20.673 26.7641 17.9505 24 12.0015 24Z"
        fill="#38B2AC"
      />
    </svg>
  )
}
